import Reveal from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

const DEFAULT_SECTIONS = [
  { title: "7-day return window", body: "If your order arrives damaged, broken or incorrect, let us know within 7 days of delivery and we will arrange a replacement, exchange or refund. Because our pieces are fragile, we ask that you report any transit damage as early as possible." },
  { title: "What we need from you", body: "Please share your order ID along with clear photographs (or a short video) of the item and its packaging within 48 hours of delivery. This helps us verify the damage with our delivery partner and resolve your request quickly." },
  { title: "Exchange or refund", body: "For damaged or incorrect items you can choose a replacement piece, an exchange for another product of equal value, or a full refund. Approved refunds are processed to your original payment method within 5–7 business days." },
  { title: "What can't be returned", body: "Items that have been used, washed or damaged after delivery cannot be returned. Natural handmade variations in glaze, tone and shape are not defects and are not eligible for return. Sale pieces marked as final sale cannot be exchanged." },
  { title: "Cancellations", body: "Orders can be cancelled free of charge any time before dispatch. Once an order has been dispatched, it can no longer be cancelled, but our return window still applies on delivery." },
];

const Returns = () => {
  const { c } = useContent();
  const sections = c("returns_sections", DEFAULT_SECTIONS);
  return (
    <div className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-8" data-testid="returns-page">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.28em] text-terra">Shop with confidence</p>
        <h1 className="mt-3 font-serif text-3xl tracking-tight text-espresso sm:text-4xl">Returns &amp; Exchange Policy</h1>
        <p className="mt-4 text-sm leading-relaxed text-clay/70">{c("returns_intro", "Ceramics are fragile, and we pack every order with great care. If something still goes wrong, here's exactly how we make it right.")}</p>
      </Reveal>
      <div className="mt-10 space-y-4">
        {sections.map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 0.05, 0.25)}>
            <div className="rounded-2xl border border-linen bg-white p-6">
              <h2 className="font-serif text-lg text-espresso">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-clay/70">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Returns;
